import React, {Component} from "react";
import { Link } from "react-router-dom";
import './PaletteList.css';


class PaletteList extends Component {
    
    // goToPalette(id){
    //     this.props.history.push(`/palette/${id}`);
    // }
    render(){
        const {paletteColour} = this.props;
        return(


            <div className="paletteList">
              <h1>Palettes</h1>  
              <div className="allPalettes">
            
            
            {paletteColour.map(palette => (
                <Link className="palette-link" to={`/palette/${palette.id}`}>
                <div className="miniPalette">
                {palette.colours.map(colour => (
                    <div className="paletteList-minidiv" style={{backgroundColor: colour.colour}}/>
                ))}
                <div className="paletteList-link" >{palette.paletteName}{palette.emoji}</div>
                </div>
                </Link>
            ))}
</div>

            </div>
            
            
        );
    }
}

export default PaletteList;